import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';
import { qualityDataQry } from '../gql/qualityDataQry';
import { useApolloClient } from '@apollo/client';
import { CREATE_GET_NUVO_DELIVERIES } from '../graphqlDefs/containers/mutations';
import { conversionRate, QUANTITY_PRECISION } from '../constants/Conversion';
import { getDeliveriesImporterSetting } from '../component/utils/deliveries';
import { PAGES } from '../constants/Pages';
import { conditioningDataQry } from '../gql/conditioningDataQry';
import { getMessage } from '../translations';

const NuvoApp = () => {
  const client = useApolloClient();
  const [activeLoader, setActiveLoader] = useState(true);
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(`/${PAGES.UPLOADERSCREEN}`);
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_DELIVERIES_HAROLD_WEB_URL}`, '_blank');
  };
  const [conditioningDropdownData, setConditioningDropdownData] = useState();
  const conditioningData = useQuery(conditioningDataQry);
  const [result, setResult] = useState('');
  // State to define for fetching quality names from database
  const [dropdownData, setDropdownData] = useState();
  const qualityData = useQuery(qualityDataQry);
  const fetchData = () => {
    const names =
      qualityData.data && qualityData.data?.qualities
        ? qualityData.data?.qualities?.map((quality) => ({
          label: quality?.name,
          alternativeMatches: [quality?.id],
          value: quality?.id,
          type: 'string',
        }))
        : '>>';

    const conditioninNames =
      conditioningData.data && conditioningData.data?.conditionnings
        ? conditioningData.data?.conditionnings?.map((conditionV) => ({
          label: conditionV?.value,
          alternativeMatches: [conditionV?.value],
          value: conditionV?.value,
          type: 'string',
        }))
        : '>>';

    setConditioningDropdownData(conditioninNames);
    // Update quality names to dropdown state
    setDropdownData(names);
    if (names !== '' || names !== undefined || conditioninNames !== '' || conditioninNames !== undefined) {
      setActiveLoader(false);
    }
  };

  useEffect(() => {
    if (qualityData.data !== undefined) {
      fetchData();
    }
  }, [qualityData.data]);

  // Fetch user unit from URL
  const { id } = useParams();
  const [userUnit, deliverType, deviationType] = id.split('&');
  const userDeliveryType = deliverType;
  const userDeviationType = deviationType;
  // Conversion function from user quantity to KG,Ton,St..etc unit
  const volumeConversion = (fromUnit, toUnit, quantity) => {
    if (conversionRate[fromUnit] && conversionRate[fromUnit][toUnit]) {
      const getVolumicConversionRates = conversionRate[fromUnit][toUnit];
      let convertedValue = quantity * getVolumicConversionRates;
      const precision =
        QUANTITY_PRECISION[toUnit] === 'PRECISION'
          ? 2
          : QUANTITY_PRECISION[toUnit];
      if (!isNaN(precision) && Number.isInteger(precision)) {
        convertedValue = convertedValue.toFixed(precision);
      }
      return convertedValue;
    } else {
      return null; // Invalid unit conversion
    }
  };
  // Conversion function to fetch quality ids from database
  function fetchQualityId(reqQulName) {
    let retQulId = 0;
    if (reqQulName !== '' && reqQulName) {
      retQulId = reqQulName;
    }
    return retQulId;
  }

  function fetchContainerOperationQuality(qualityId, harold_no) {
    return {}; // Return an empty object if no valid data is found
  }

  const devaiationValue = conditioningData.data?.otherProducts.find(
    (item) =>
      ["STERILE", "sterile", "Sterile"].includes(item.name) &&
      item.group === "Deviation"
  );

  // Below function we are calling after submission and will push to database
  async function saveDeliveries(res) {
    // Perform the mutation for all containers at once
    try {
      const { data } = await client.mutate({
        mutation: CREATE_GET_NUVO_DELIVERIES,
        variables: { input: res },
      });
      return { flg: true, message: 'Success', data };
    } catch (error) {
      console.error('Mutation Error:', error); // Debugging statement
      return { flg: false, message: error.message };
    }
  }

  const importerSettings = getDeliveriesImporterSetting({
    dropdownData,
    conditioningDropdownData,
  });
  const handleImportResult = async (result, errors, complete, logs) => {
    console.log(result);
    if (errors.length === 0) {
      const rest = await saveDeliveries(result);
      if (rest.flg) {
        complete();
        setResult(result);
      } else {
        complete(new RejectSubmitResult('Error', rest.message));
        return false;
      }
    } else {
      complete(
        new RejectSubmitResult('Error', 'Please fill the required data.')
      );
      return false;
    }
  };

  return dropdownData === undefined ? (
    <div className={activeLoader === true ? 'bgl-clr loading' : 'bgl-clr loading'}>
      <div className='loaderText'>
        <p className=''>{getMessage('LOADING_TEXT')} </p>
        <span>
          <i></i>
          <i></i>
          <i></i>{' '}
        </span>
      </div>
    </div>
  ) : (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ? (
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('CHECKOUT_DELIVERIES_ON_APP')}
              </button>
            ) : (
              <NuvoImporter
                licenseKey={licenseKey}
                settings={importerSettings}
                onResults={(result, errors, complete, logs) =>
                  handleImportResult(result, errors, complete, logs)
                }
                dataHandler={{
                  reviewStep: async (modifier, data) => {
                    const dataLength = data.length;
                    for (let i = 0; i < dataLength; i++) {
                      const element = data[i];
                      if (
                        element.harold_number !== '' &&
                        element.harold_number === 'Totals'
                      ) {
                        modifier.removeRow(i);
                        modifier.removeColumn('qualityName');
                      }
                    }
                  },
                }}
                onEntryInit={(row, rowIndex) => {
                  let currentDate = new Date(); // Get the current date and time
                  const deliveryDate = row.dateOfDelivery;
                  const netWeightQty = row.quantityQuantity;
                  const grossWeightQty =
                    row.grossQuantityQuantity || netWeightQty;
                  const qlName = row.qualityName;
                  const refNo = row.referenceNumber;
                  const julesNo = row.harold_number;
                  const packageReference = row.packageReference;
                  let getFormulatedKgNetQty = 0;
                  let getFormulatedTonNetQty = 0;
                  let getFormulatedKgGrossQty = 0;
                  let getFormulatedTonGrossQty = 0;
                  let getQulityID = 0;
                  let opeID = 0;
                  let getHaroldNo = 0;
                  let getSellOperationId = 0;
                  // let getContainerOperationQualityId=0;
                  let getOperationID = 0;
                  let getContainerId = 0;
                  let getReferenceNo = 0;
                  let getOperationQualityId = 0;
                  let numberOfPieces = row.numberOfPieces;
                  let sterileQuantity = row.sterileQuantity;
                  let sterileGrossQuantity = row.sterileGrossQuantity;
                  // Cleaning Funtions
                  if (userUnit) {
                    // For Net Qty Calculations
                    getFormulatedKgNetQty = netWeightQty;
                    // getFormulatedKgNetQty = volumeConversion(
                    //   userUnit,
                    //   'Kg',
                    //   netWeightQty
                    // );

                    getFormulatedTonNetQty = netWeightQty;
                    // getFormulatedTonNetQty = volumeConversion(
                    //   userUnit,
                    //   'T',
                    //   netWeightQty
                    // );

                    getFormulatedKgGrossQty = grossWeightQty;
                    // getFormulatedKgGrossQty = volumeConversion(
                    //   userUnit,
                    //   'Kg',
                    //   grossWeightQty
                    // );
                    getFormulatedTonGrossQty = grossWeightQty;
                    // getFormulatedTonGrossQty = volumeConversion(
                    //   userUnit,
                    //   'T',
                    //   grossWeightQty
                    // );
                  }
                  if (qlName) {
                    getQulityID = fetchQualityId(qlName);
                  }
                  if (julesNo) {
                    let containerRes = fetchContainerOperationQuality(
                      getQulityID,
                      julesNo
                    );
                    if (containerRes !== undefined) {
                      opeID =
                        containerRes.containerOperationQualityId === ''
                          ? 0
                          : containerRes.containerOperationQualityId;
                      // getContainerOperationQualityId = containerRes.containerOperationQualityId;
                      getSellOperationId = containerRes.sellOperationId;
                      getOperationID = containerRes.buyOperationId;
                      getHaroldNo = containerRes.harold_number;
                      getContainerId = containerRes.containerId;
                      getReferenceNo = containerRes.referenceNumber;
                      getOperationQualityId = containerRes.operationQualityId;
                    }
                  }
                  if (row.harold_number !== 'Totals') {
                    return {
                      quantityQuantity: {
                        value: getFormulatedKgNetQty,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },

                      quantityInTons: {
                        value: getFormulatedTonNetQty,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },
                      grossQuantityQuantity: {
                        value: getFormulatedKgGrossQty,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },
                      grossQuantityInTons: {
                        value: getFormulatedTonGrossQty,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },
                      containerId: {
                        value: getContainerId,
                        info: [
                          {
                            message: 'Container id from reference no ',
                            level: 'info',
                          },
                        ],
                      },
                      operationQualityId: {
                        value: getOperationQualityId,
                        info: [
                          {
                            message: 'Operation quality id from reference no ',
                            level: 'info',
                          },
                        ],
                      },
                      sterileQuantity: {
                        value: sterileQuantity,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },
                      sterileGrossQuantity: {
                        value: sterileGrossQuantity,
                        info: [
                          {
                            message: '',
                            level: 'info',
                          },
                        ],
                      },
                      referenceNumber: {
                        value: refNo,
                        info: [
                          {
                            message: 'Reference no ',
                            level: 'info',
                          },
                        ],
                      },
                      harold_number: {
                        value: julesNo,
                        info: [
                          {
                            message: 'Jules No',
                            level: 'info',
                          },
                        ],
                      },
                      buyOperationId: {
                        value: getOperationID,
                        info: [
                          {
                            message: 'Buy operation no from reference no ',
                            level: 'info',
                          },
                        ],
                      },
                      sellOperationId: {
                        value: getSellOperationId,
                        info: [
                          {
                            message: 'Sell operation no from reference no ',
                            level: 'info',
                          },
                        ],
                      },
                      containerOperationQualityId: {
                        value: opeID,
                        info: [
                          {
                            message: 'Container operation quality id ',
                            level: 'info',
                          },
                        ],
                      },
                      deliveryType: {
                        value: userDeliveryType,
                        info: [
                          {
                            message: 'User selected loading type',
                            level: 'info',
                          },
                        ],
                      },
                      qualityId: {
                        value: getQulityID,
                        info: [
                          {
                            message: 'From material name to material ID',
                            level: 'info',
                          },
                        ],
                      },
                      packageReference: {
                        value: packageReference,
                        info: [
                          {
                            message: 'Package Reference',
                            level: 'info',
                          },
                        ],
                      },
                      deliveryTareWeightVolume: {
                        value: userUnit,
                        info: [
                          {
                            message: 'Delivery tare weight volume',
                            level: 'info',
                          },
                        ],
                      },

                      // Added this for tentative error issue need to upload only from sheet
                      dateOfDelivery: {
                        value: deliveryDate,
                        info: [
                          {
                            message: 'Delivery date and time.',
                            level: 'info',
                          },
                        ],
                      },
                      numberOfPieces: {
                        value: numberOfPieces,
                        info: [
                          {
                            message: 'Number of pieces',
                            level: 'info',
                          },
                        ],
                      },
                    };
                  }
                }}
              >
                {getMessage('IMPORT_DELIVERIES')}
              </NuvoImporter>
            )}
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          <div className='white-box'>
            {Object.keys(result).length !== 0 && (
              <pre>
                {typeof result === 'string'
                  ? result
                  : JSON.stringify(result, null, 2)}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NuvoApp;